export default () => ({
  addProductsDrawer: {
    width: '85vw',
    overflowX: 'hidden'
  },
  addProductsContainer: {
    padding: 15
  }
});
